import { call, put, takeLatest } from 'redux-saga/effects';
import {
  CreateSyncConfiguration,
  DeleteSyncConfiguration,
  SyncConfiguration,
  UpdateSyncConfiguration,
} from '../../helpers/syncConfig_helper';
import {
  getSyncConfigurationSuccess,
  getSyncConfigurationFail,
  addSyncConfigurationFail,
  addSyncConfigurationSucces,
} from './actions';
import { SyncConfigTypes } from './actionTypes';

function* getSyncConfig(action: any) {
  try {
    const response: Promise<any> = yield call(SyncConfiguration, action);
    if (response) {
      yield put(getSyncConfigurationSuccess(response));
    }
  } catch (error) {
    yield put(getSyncConfigurationFail(error));
  }
}

function* createSyncConfig(action: any) {
  try {
    const { errors, data }: { errors: any; data: any } = yield call(
      CreateSyncConfiguration,
      action.payload,
    );

    if (errors?.length > 0) {
      yield put(addSyncConfigurationFail(errors[0].message));
    } else {
      yield put(addSyncConfigurationSucces(data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* updateSyncConfig(action: any) {
  try {
    yield call(UpdateSyncConfiguration, action.payload);
  } catch (error) {
    console.log(error);
  }
}
function* deleteSyncConfig(action: any) {
  try {
    yield call(DeleteSyncConfiguration, action.payload);
  } catch (error) {
    console.log(error);
  }
}

function* SyncConfigSaga() {
  yield takeLatest(SyncConfigTypes.GET_SYNC_OPERATIONS, getSyncConfig);
  yield takeLatest(SyncConfigTypes.ADD_SYNC_OPERATIONS, createSyncConfig);
  yield takeLatest(SyncConfigTypes.UPDATE_SYNC_OPERATIONS, updateSyncConfig);
  yield takeLatest(SyncConfigTypes.DELETE_SYNC_OPERATIONS, deleteSyncConfig);
}

export default SyncConfigSaga;
